import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import { getAcademyLogoConfig } from '../views-components/AcademyLogo';
import { getChatspotLogoConfig } from '../views-components/ChatSpotLogo';
import { getConnectLogoConfig } from '../views-components/ConnectLogo';
const SpecificLogoConfig = {
  [Flow.Connect]: getConnectLogoConfig,
  [Flow.Academy]: getAcademyLogoConfig,
  [Flow.ChatSpot]: getChatspotLogoConfig
};
export const getSpecificLogoConfig = isMobile => {
  const flowKey = getFlowKey();
  let url;
  let altText = 'Hubspot';
  let width;
  let height;
  const getSpecificLogoConfigFunction = SpecificLogoConfig[flowKey];

  if (getSpecificLogoConfigFunction) {
    const logoConfig = getSpecificLogoConfigFunction(isMobile);
    url = logoConfig.url;
    altText = logoConfig.altText;
    width = logoConfig.width;
    height = logoConfig.height;
  }

  return {
    url,
    altText,
    width,
    height
  };
};